
import React from 'react';
import { Button } from "@/components/ui/button";
import ComplianceHeader from '@/components/compliance/ComplianceHeader';
import ScoreGrid from '@/components/compliance/ScoreGrid';
import DeadlinesCalendar from '@/components/compliance/DeadlinesCalendar';
import RegulatoryIntelligence from '@/components/compliance/RegulatoryIntelligence';
import { ComplianceCategoryProps } from '@/components/compliance/ScoreGrid';
import { DeadlineItemProps } from '@/components/compliance/DeadlineItem';
import { CircularItemProps } from '@/components/compliance/CircularItem';

const complianceCategories: ComplianceCategoryProps[] = [
  { 
    id: 1, 
    name: "RBI Compliance", 
    progress: 92, 
    total: 24, 
    completed: 22, 
    pending: 2 
  },
  { 
    id: 2, 
    name: "State Regulations", 
    progress: 80, 
    total: 15, 
    completed: 12, 
    pending: 3 
  },
  { 
    id: 3, 
    name: "Central Regulations", 
    progress: 96, 
    total: 25, 
    completed: 24, 
    pending: 1 
  },
  { 
    id: 4, 
    name: "Municipal Regulations", 
    progress: 85, 
    total: 13, 
    completed: 11, 
    pending: 2 
  },
];

const upcomingDeadlines: DeadlineItemProps[] = [
  { 
    id: 1, 
    name: "Quarterly ALM Statement", 
    deadline: "2025-05-15", 
    category: "RBI", 
    status: "high" 
  },
  { 
    id: 2, 
    name: "GST Return Filing", 
    deadline: "2025-05-20", 
    category: "Central", 
    status: "medium" 
  },
  { 
    id: 3, 
    name: "FLDG Compliance Report", 
    deadline: "2025-05-25", 
    category: "RBI", 
    status: "high" 
  },
  { 
    id: 4, 
    name: "Annual Secretarial Audit", 
    deadline: "2025-06-10", 
    category: "MCA", 
    status: "low" 
  },
];

const recentCirculars: CircularItemProps[] = [
  { 
    id: 1, 
    title: "Digital Lending Guidelines", 
    issuer: "RBI", 
    date: "2025-04-20", 
    summary: "New guidelines related to digital lending through mobile apps and web platforms." 
  },
  { 
    id: 2, 
    title: "Co-Lending Model Regulations", 
    issuer: "RBI", 
    date: "2025-04-15", 
    summary: "Updated regulations for co-lending arrangements between banks and NBFCs." 
  },
  { 
    id: 3, 
    title: "First Loss Default Guarantee Norms", 
    issuer: "RBI", 
    date: "2025-04-10", 
    summary: "New regulations regarding FLDG arrangements between lending service providers and regulated entities." 
  },
];

const Compliance: React.FC = () => {
  return (
    <div className="space-y-6">
      <ComplianceHeader />
      <ScoreGrid categories={complianceCategories} />
      
      <div className="grid gap-6 md:grid-cols-3">
        <DeadlinesCalendar deadlines={upcomingDeadlines} />
        <RegulatoryIntelligence circulars={recentCirculars} />
      </div>
    </div>
  );
};

export default Compliance;
